module.exports = __webpack_public_path__ + "static/media/smile-beam.bf9c104a.svg";